import React from 'react';
import { Paragraph } from '../../../common/elements/paragraph/paragraph';

export const LastSaturdays: React.FC = () => {
    const getLastSaturday = (year: number, month: number): Date => {
        const lastDayOfMonth = new Date(year, month + 1, 0); // Laatste dag van de maand
        lastDayOfMonth.setDate(
            lastDayOfMonth.getDate() -
                (lastDayOfMonth.getDay() === 6
                    ? 0
                    : (lastDayOfMonth.getDay() + 1) % 7),
        ); // Terug naar zaterdag
        return lastDayOfMonth;
    };

    const getAllLastSaturdaysFor2026 = () => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const saturdays = Array.from({ length: 12 }, (_, month) =>
            getLastSaturday(2026, month),
        );

        // Voeg 13 juni 2026 toe
        saturdays.push(new Date(2026, 5, 13));

        const filteredDates = saturdays.filter(
            date => date.getTime() > today.getTime() - 24 * 60 * 60 * 1000,
        );

        // Sorteer de lijst chronologisch
        filteredDates.sort((a, b) => a.getTime() - b.getTime());

        return filteredDates;
    };

    const formatDate = (date: Date): string => {
        return date.toLocaleDateString('en-US', {
            month: 'long',
            day: 'numeric',
        });
    };

    const lastSaturdays2026 = getAllLastSaturdaysFor2026();

    return (
        <Paragraph>
            <strong>2026 dates:</strong>
            {lastSaturdays2026.map((date, index) => {
                return (
                    <React.Fragment key={index}>
                        <br />
                        {formatDate(date)}
                    </React.Fragment>
                );
            })}
        </Paragraph>
    );
};
